import styled from 'styled-components';
import ReactQuill from 'react-quill';
var TextEditor = styled(ReactQuill).withConfig({
  displayName: "TextEditorstyles__TextEditor",
  componentId: "sc-nb2lif-0"
})(["box-shadow:inset 0 1px 0 0 var(--dentsu-color-n250);"]);
export var Styled = {
  TextEditor: TextEditor
};